// extracted by mini-css-extract-plugin
export default {"thanks_wrapper":"thanksforcontactingus_thanks_wrapper__YHHOJ","thanks_title":"thanksforcontactingus_thanks_title__OJGBM"};